import {createDraftSafeSelector} from '@reduxjs/toolkit';

const selectModalState = (state) => state.modal;

export const selectGlobalModals = createDraftSafeSelector(selectModalState, (state) => state.globalModals);

export const selectIsAnyRenderedPopup = createDraftSafeSelector(selectGlobalModals, (modals) => !!modals?.length);

export const selectTopRenderedPopup = createDraftSafeSelector(selectGlobalModals, (modals) => {
    if (!modals?.length) return null;

    const alwaysDisplayModals = modals.filter((modal) => modal.alwaysDisplay);

    if (alwaysDisplayModals.length) {
        return alwaysDisplayModals[alwaysDisplayModals.length - 1];
    }

    return modals[modals.length - 1];
});

export const selectVisibleGlobalModal = (modalType) =>
    createDraftSafeSelector(selectGlobalModals, (modals) => modals.some((modal) => modal.modalType === modalType));
